import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, catchError, of, withLatestFrom, EMPTY, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContactsActions } from '../state/contacts/contacts.actions';
import { ContactsService } from '../../services/contacts.service';
import { contactsFeature } from '../state/contacts/contacts.feature';

export const loadOrgContacts = createEffect(
  (
    actions$ = inject(Actions),
    contactsService = inject(ContactsService),
    store = inject(Store),
  ) => {
    return actions$.pipe(
      ofType(ContactsActions.loadOrgContacts),
      withLatestFrom(store.select(contactsFeature.selectOrgContactsLoaded)),
      switchMap(([, loaded]) => {
        if (loaded) {
          return EMPTY;
        }
        return contactsService.getAllContacts().pipe(
          map((contacts) => ContactsActions.loadOrgContactsSuccess({ contacts })),
          catchError((error: Error) =>
            of(ContactsActions.loadOrgContactsFail({ error: error.message })),
          ),
        );
      }),
    );
  },
  { functional: true },
);

export const loadAccountContactGroups = createEffect(
  (
    actions$ = inject(Actions),
    contactsService = inject(ContactsService),
    store = inject(Store),
  ) => {
    return actions$.pipe(
      ofType(ContactsActions.loadAccountContactGroups),
      switchMap(({ accountId }) => {
        return store.select(contactsFeature.selectAccountContactGroupsByAccountId(accountId)).pipe(
          take(1),
          switchMap((cached) => {
            if (cached) {
              return EMPTY;
            }
            return contactsService.getAccountContactGroups(accountId).pipe(
              map((groups) => ContactsActions.loadAccountContactGroupsSuccess({ accountId, groups })),
              catchError((error: Error) =>
                of(ContactsActions.loadAccountContactGroupsFail({ accountId, error: error.message })),
              ),
            );
          }),
        );
      }),
    );
  },
  { functional: true },
);
